import React, { useState, useEffect } from 'react'

//peticiones
import axios from 'axios'
import ScrollContainer from 'react-indiana-drag-scroll'
import * as constant from '../../global/const'
import auth from '../../Helpers/auth'

import noimage from '../../assets/images/base-1.png'
import iconoCambiar from '../../assets/icons/iconoCambiar.svg'

import { TransparentLoader } from "../Loader/transparentLoader.component";

import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";


const Categorias = () => {

    const sucursal = useSelector(state => state.page.sucursal);
    const categories = useSelector(state => state.categories);
    const [items, setitems] = useState([]);
    const [categorias, setcategorias] = useState(true);
    const [load, setLoad] = useState()

    let user = JSON.parse(auth.getUsuario());
    let history = useHistory();

    const getCategorias = async () => {
        setLoad(true)
        await axios.get(constant.GETCATEGORIAS + `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}&correo=${user.email}`)
            .then(
                (response) => {
                    setLoad(false)
                    setitems(response.data);
                }
            ).catch(
                (err) => {
                    console.log(err);
                }
            )
    }

    const getMarcas = async () => {
        await axios.get(constant.GETMARCAS + `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}&correo=${user.email}`)
            .then(
                (response) => {
                    setitems(response.data);
                }
            ).catch(
                (err) => {
                    console.log(err);
                }
            )
    }

    useEffect(() => {
        //console.log((sucursal && categories.length) ? "intento" : "entro");
        if (sucursal && categories.length) getCategorias();
    }, [sucursal, categories])

    return (
        <div className="contenedor">
            <div className="header">
                <h1 >{categorias ? 'Categorías' : 'Marcas'}</h1>
                <div className="card-cambiar" onClick={
                    () => {
                        if (categorias) {
                            getMarcas()
                        } else {
                            getCategorias()
                        }
                        setcategorias(!categorias);
                    }}>
                    {/**<i className="far fa-image"></i>*/}
                    <img src={iconoCambiar} ></img>
                    <h1 className="no-seleccionable">Cambiar a <span>{!categorias ? 'categorías' : 'marcas'}</span></h1>
                </div>
            </div>
            <ScrollContainer horizontal={true} nativeMobileScroll={true} hideScrollbars={true}>
                <div className="body">
                    {load
                        ?
                        <TransparentLoader /> :

                        items.length !== 0
                            ?
                            items
                                .sort((t1, t2) => t1.orden - t2.orden)
                                .slice(0, 13)
                                .map(
                                    (item, i) => (
                                        <div key={i} className="card-container"
                                            onClick={() => {
                                                // let categoria = categorias ? 'categorias' : 'marcas';
                                                history.push({
                                                    pathname:
                                                        categorias
                                                            ?
                                                            '/Catalogo/' + 'Categoria' + '/' + item.id + '/' + item.titulo + "/1"
                                                            :
                                                            'Catalogo/' + 'Marcas/' + item.id + '/' + item.titulo.trim() + '/1'
                                                    ,
                                                })

                                            }}
                                        >
                                            <div className="background">

                                            </div>
                                            <div className="card" >
                                                <img
                                                    className="img-product"
                                                    src={`${constant.URL_BASE_IMAGES}Web/${categorias ? 'categorias' : 'marcas'}/${item.id}.png`}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = noimage }}
                                                >
                                                </img>
                                            </div>
                                            <div className="boton">
                                                <h1>{item.titulo}</h1>
                                            </div>
                                            <div className="desc">
                                                <h5>{item.descripcion}</h5>
                                            </div>
                                        </div>
                                    ))
                            : null
                    }
                </div>
            </ScrollContainer>
            <div className="footer">
                <a
                    onClick={
                        () => {
                            let categoria = "Categoria";
                            history.push({
                                pathname: '/Catalogo/' + categoria + '/' + "-1" + '/' + "Todos/1",
                            })
                        }
                    }
                >
                    Todas las {categorias ? 'categorías' : 'marcas'}
                </a>
            </div>

        </div>
    )
}

const Item = ({ item, key }) => {
    const [hover, setHover] = useState(false);
    return (
        <>
        </>
    )
}

export default Categorias;
